/*
 * @Author: your name
 * @Date: 2021-01-13 17:37:21
 * @LastEditTime: 2021-01-18 09:45:13
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \vue3-element-admin\src\router\globalRoutes.js
 */
export default [
    {
        path: "/dev_login",
        name: "dev_login",
        component: () => import("@/views/old_mini/dev_login.vue"),
    },
    // 创建农场
    {
        path: "/create_farm",
        name: "CreateFarm",
        meta: { keepAlive: true },
        component: () => import("@/views/old_mini/create_farm/index.vue"),
    },
    // 农事记录
    {
        path: "/agri_record",
        name: "AgriRecord",
        meta: { showTabbar: true, keepAlive: true },
        component: () => import("@/views/old_mini/agri_record/index.vue"),
    },
    // 编辑地图
    {
        path: "/edit_map",
        name: "EditMap",
        meta: { keepAlive: true },
        component: () => import("@/views/old_mini/create_farm/editMap.vue"),
    },
    // 长势报告
    {
        path: "/growth_report",
        name: "GrowthReport",
        meta: { showTabbar: true, keepAlive: true },
        component: () => import("@/views/old_mini/growth_report/index.vue"),
    },
    // 具体预警详情
    {
        path: "/alert_detail",
        name: "AlertDetail",
        meta: { keepAlive: false },
        component: () => import("@/views/old_mini/growth_report/alert_detail.vue"),
    },
    // 农事互动列表
    {
        path: "/interaction_list",
        name: "InteractionList",
        meta: { keepAlive: true },
        component: () => import("@/views/old_mini/interactionList/index.vue"),
    },
    // 勾画发生区域
    {
        path: "/draw_region",
        name: "DrawRegion",
        meta: { keepAlive: true },
        component: () => import("@/views/old_mini/interactionList/drawRegion.vue"),
    },
    // 农事详情
    {
        path: "/work_detail",
        name: "WorkDetail",
        meta: { keepAlive: true },
        component: () => import("@/views/old_mini/work_detail/index.vue"),
    },
    // 农事详情 - 查看区域
    {
        path: "/view_area",
        name: "WorkViewArea",
        meta: { keepAlive: true },
        component: () => import("@/views/old_mini/work_detail/components/mapInfo.vue"),
    },
    {
        path: "/select_crop",
        name: "SelectCrop",
        meta: { keepAlive: true },
        component: () => import("@/views/old_mini/create_farm/selectCrop.vue"),
    },
    // 农事档案
    {
        path: "/agri_file",
        name: "AgriFile",
        meta: { showTabbar: true, keepAlive: true },
        component: () => import("@/views/old_mini/agri_file/index.vue"),
    },
    // 农事记录详情
    {
        path: "/record_details",
        name: "RecordDetails",
        meta: { keepAlive: true },
        component: () => import("@/views/old_mini/recordDetails/index.vue"),
    },
    // 地图管理
    {
        path: "/map_manage",
        name: "MapManage",
        meta: { keepAlive: true },
        component: () => import("@/views/old_mini/recordDetails/mapManage.vue"),
    },
    // 农事详情
    {
        path: "/agri_record_detail",
        name: "AgriRecordDetail",
        meta: { keepAlive: true },
        component: () => import("@/views/old_mini/agri_record_detail/index.vue"),
    },
    // 农事执行
    {
        path: "/work_execute",
        name: "WorkExecute",
        meta: { showTabbar: true, keepAlive: true },
        component: () => import("@/views/old_mini/work_execute/index.vue"),
    },
    // 调查问卷 - 选择农事类别
    {
        path: "/survey_entry",
        name: "SurveyEntry",
        meta: { keepAlive: false },
        component: () => import("@/views/old_mini/work_execute/surveyEntry.vue"),
    },
    // 农场信息
    {
        path: "/farm_info",
        name: "FarmInfo",
        meta: { keepAlive: true },
        component: () => import("@/views/old_mini/farm_info/index.vue"),
    },
    // 录入信息
    {
        path: "/entry_information",
        name: "EntryInformation",
        meta: { keepAlive: true },
        component: () => import("@/views/old_mini/entry_information/index.vue"),
    },
    // 选择常驻点位
    {
        path: "/entry_select_location",
        name: "EntrySelectLocation",
        meta: { keepAlive: false },
        component: () => import("@/views/old_mini/entry_information/selectLocation.vue"),
    },
    // 分区相册
    {
        path: "/region_albums",
        name: "RegionAlbums",
        meta: { keepAlive: true },
        component: () => import("@/views/old_mini/agri_file/pages/regionAlbums.vue"),
    },
    // 新增分区
    {
        path: "/add_zone",
        name: "AddZone",
        meta: { keepAlive: true },
        component: () => import("@/views/old_mini/agri_file/pages/addZone.vue"),
    },
    // 农情相册地图
    {
        path: "/album_map",
        name: "AlbumMap",
        meta: { keepAlive: true },
        component: () => import("@/views/old_mini/agri_file/pages/albumMap.vue"),
    },
    // 更多农场
    {
        path: "/all_garden",
        name: "AllGarden",
        meta: { keepAlive: true },
        component: () => import("@/components/allGarden.vue"),
    },
    // 长势跟踪记录
    {
        path: "/growth_track",
        name: "GrowthTrack",
        meta: { keepAlive: true },
        component: () => import("@/views/old_mini/agri_file/pages/growthTrack.vue"),
    },
    // 定位校验通过桥接（小程序写 localStorage 后回退）
    {
        path: "/location_check_pass",
        name: "LocationCheckPass",
        component: () => import("@/views/old_mini/agri_file/pages/locationCheckPass.vue"),
    },
    // 病虫害互动选地块
    {
        path: "/pest_interact",
        name: "PestInteract",
        meta: { keepAlive: true },
        component: () => import("@/views/old_mini/agri_file/pages/pestInteract.vue"),
    },
    // 初次种植诊断报告
    {
        path: "/diagnosis_report",
        name: "DiagnosisReport",
        meta: { showTabbar: true, keepAlive: true },
        component: () => import("@/views/old_mini/agri_file/pages/diagnosisReport.vue"),
    },
];
